//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { articleMenu } from '~/utils/article';

export default {
  name: 'ArticleList',
  props: { categoryId: { default: 0, type: Number } },
  data() {
    return {
      // api文章分類(null = 熱門, 0 = 經營管理, 1 = 產業趨勢, 2 = 求職指南 )
      articleMenu: [{ label: '熱門', value: 'news', color: 'blue' }].concat(
        articleMenu,
      ),
      articleMenuActive: this.categoryId + 1,
      articleList: [],
      pagerInfo: { size: 6, current: 1, total: 0 },
    };
  },
  computed: {
    showPager() {
      if (this.pagerInfo.size > this.pagerInfo.total) return false;
      return true;
    },
  },
  methods: {
    getArticles(categoryId) {
      this.$api('getArticleList', {
        categoryId,
        ...this.pagerInfo,
      }).then(data => {
        this.articleList = data.records;

        const { current, size, total } = data;
        this.pagerInfo = { ...this.pagerInfo, current, size, total };
      });
    },
    onArticleMenuClick(index) {
      this.articleMenuActive = index;
      this.pagerInfo = this.$options.data().pagerInfo;
      this.getArticles(index <= 0 ? null : index - 1);
    },
    handleCurrentChange(current) {
      this.pagerInfo.current = current;
      this.getArticles();
    },
  },
  mounted() {
    this.getArticles();
  },
};
